import { Component, Input, SimpleChanges } from '@angular/core';
import { Anlegg } from 'src/app/services/forbruk/forbruk.types';
import { toRoundNumber } from '../../../forbruk/forbrukstall/forbrukstall-utils';
import { sumNum } from 'src/app/utils/array-utils';
import { hasChanged } from 'src/app/utils/change-utils';
import { Avtaler } from 'src/app/services/avtale/avtale.types';

@Component({
  selector: 'app-kostnadstall-day',
  templateUrl: './day.component.html',
  styleUrls: ['./day.component.scss']
})
export class KostnadstallDayComponent {
  @Input() valgtAnlegg: Anlegg;
  @Input() valgtAvtale: Avtaler;
  @Input() _foretakMap: Map<number, string>;
  @Input() selectedDate: Date;
  @Input() isStromstotteToggled: boolean;

  toRoundNumber = toRoundNumber;

  isPlusskunde: boolean;
  stromFastbelop: number;
  stromForbrukbelop: number;
  inntektProd: number;
  stromTotal: number;
  nettleieFastbelop: number;
  nettleieEnergiledd: number;
  nettleieAvgifter: number;
  nettleieTotal: number;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (hasChanged([changes.valgtAnlegg, changes.isStromstotteToggled])) {
      this.getValues();
    }
  }

  getValues() {
    this.isPlusskunde = this.valgtAnlegg.plusskunde;

    this.stromFastbelop = this.valgtAnlegg.priser?.fastbelopMnd;

    this.stromForbrukbelop =
      sumNum(this.valgtAnlegg.verdiList?.map((x) => x.belopKraft)) || 0;
    if (this.isPlusskunde) {
      this.inntektProd =
        sumNum(this.valgtAnlegg.verdiList?.map((x) => -x.belopPlussverdi)) || 0;
      this.stromTotal =
        this.stromFastbelop + this.stromForbrukbelop - this.inntektProd || 0;
    } else {
      this.stromTotal = this.stromFastbelop + this.stromForbrukbelop || 0;
    }
    this.nettleieFastbelop =
      this.valgtAnlegg.priser.nettleiepriser?.fastbelopMnd || 0;
    this.nettleieEnergiledd =
      this.valgtAnlegg.priser.nettleiepriser?.energi || 0;
    this.nettleieAvgifter =
      this.valgtAnlegg.priser.nettleiepriser?.forbruksavgift || 0;
    this.nettleieTotal =
      this.nettleieAvgifter +
        this.nettleieEnergiledd +
        this.nettleieFastbelop || 0;
  }
}
